import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice'
import usersReducer from "./usersSlice";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { loginSuccess } from './actionTypes';

const rootReducer = combineReducers({
	auth: authReducer,
	users: usersReducer,
})

const persistConfig = {
	key: 'root',
	storage,
};

const persistedReducer = persistReducer( persistConfig, rootReducer)

const store = configureStore({
	reducer: persistedReducer,
	
	// Middleware to remove serialize error
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		serializableCheck: false,
	})
});

const token = localStorage.getItem('accessToken');
if (token && typeof loginSuccess === "function") {
	store.dispatch(loginSuccess(token));
}

export const persistor = persistStore(store);
export default store;